export const TOUR_URLS = {
  DEFAULT: 'https://tour.panoee.net/iframe/VRIFYtours',
//   EAST_LEGON: 'https://tour.panoee.net/iframe/68c98f03812057c9031fd06f',
  // Add more tour URLs as needed
};

export const getTourUrl = (tourKey = 'DEFAULT') => {
  return TOUR_URLS[tourKey] || TOUR_URLS.DEFAULT;
};